import React, {useState} from 'react'
import useAxios from '../api/axios';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { useNavigate} from 'react-router-dom';
import { toast } from 'react-toastify';
import {useAuth} from '../context/AuthProvider';

export const AddCompany = () => {

    const navigate = useNavigate();

    const [name, setName] = useState('');
    const [invoicingEmail, setInvoicingEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [publicPhone, setPublicPhone] = useState('');
    const [publicEmail, setPublicEmail] = useState('');
    const [address, setAddress] = useState('');
    const [address2, setAddress2] = useState('');
    const [postalcode, setPostalcode] = useState('');
    const [city, setCity] = useState('');
    const [facebook, setFacebook] = useState('');
    const [instagram, setInstagram] = useState('');
    const [description, setDescription] = useState('');
    const [homepage, setHomepage] = useState('');

    const {addCompany} = useAuth();

    const api =useAxios();

    function validateForm() {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      let ok = true;

      
      if (!emailRegex.test(invoicingEmail)) {
          toast.error("Tarkista laskutuksen sähköposti osoite");
          ok = false;
      }
      
      if (publicEmail && !emailRegex.test(publicEmail)) {
        toast.error("Tarkista julkinen sähköposti osoite");
        ok = false;
    }

      if(name.trim().length === 0) {
          toast.error("Anna yrityksen, yhdistyksen tai myyjän nimi")
          ok = false;
      }
      
      if(phone.trim().length === 0) {
          toast.error("Anna puhelinumerosi")
          ok = false;
      }

      return ok;
  }

  const handleSubmit = async (e) => {
          e.preventDefault();    
          
          if(!validateForm()) {
              return;
          }
  
          try {              
              const response = await api.post('/addCompany',
                  JSON.stringify({ company: { name, phone, invoicingEmail, address, address2, postalcode, city, publicEmail, publicPhone, homepage,facebook, instagram, description} }),
                  {
                      headers: { 'Content-Type': 'application/json'},                    
                  }
              );
              
              addCompany(response.data);
              toast.info("Myyjän tiedot lisätty");
              navigate(-1);              
          } catch(err) {
              if(!err?.response) {
                  toast.error(err.response.data.msg);
                  //setErrMsg("Ei vastausta palvelimelta");
              } else if(err.response?.status === 400) {
                  toast.error("Palvelin virhe");
                  //setErrMsg("Palvelin virhe");
              } else if(err.response?.status === 401) {
                  toast.error("Tunnukset eivät kelpaa");
                  //setErrMsg("Tunnukset eivät kelpaa");
              } else {
                  toast.error("Myyjän tietojen lisäys epäonnistui");
                  //setErrMsg("Kirjautuminen epäonnistui");
              }
              //errRef.current.focus();
          }        
      }

      const handleGoBack = () => {
        navigate(-1); // Navigates back to the previous page
      };

  return (
    <>
    <div className="w-full h-full mx-auto text-center flex  flex-col">                
        <h1 className="text-4xl pb-2 font-bold text-blue-800">Myyjän tiedot</h1>
        <h1 className="text-sm text-white mb-2">(*) pakolliset kentät</h1>
        <form onSubmit={handleSubmit}>          
        {/*
        <div className="max-w-[400px] mt-2 w-full h-full mx-auto text-center flex  flex-col">      
        */}
        <div className="max-w-[800px] mt-2 w-full h-full mx-auto text-center flex flex-col md:flex-row gap-4">
        <div className="flex-1">
        <h1 className="text-sm text-white">Laskutustiedot</h1>
        <h1 className="text-sm text-white mb-2">vain järjestäjän kayttöön</h1>  
        <Stack direction="column" className="bg-blue-500 px-2 py-2 rounded-lg" alignItems="center" justifyContent="center" spacing={2}>
        <TextField
                  variant="filled"
                  //margin="normal"                  
                  required                  
                  id="name"
                  label="Yrityksen / yhdistyksen / myyjän nimi"
                  name="name"
                  autoComplete="nimi"
                  autoFocus
                  sx={{
                    width: 1,
                    backgroundColor: "white", // Light gray background
                    borderRadius: "8px",        // Optional: Rounded corners                    
                  }} 
                  
                  onChange={e => setName(e.target.value)}
                />
                <TextField
                  variant="filled"
                  //margin="normal"
                  required                  
                  id="email"
                  label="Sähköposti (laskutukseen)"
                  name="invoicingEmail"
                  autoComplete="sähköposti"   
                  sx={{
                    width: 1,
                    backgroundColor: "white", // Light gray background
                    borderRadius: "8px",        // Optional: Rounded corners
                  }}               
                  onChange={e => setInvoicingEmail(e.target.value)}
                />
                <TextField
                  variant="filled"
                  //margin="normal"
                  required                  
                  id="phone"
                  label="Puhelin"
                  name="phone"
                  autoComplete="phonenumber"    
                  sx={{
                    width: 1,
                    backgroundColor: "white", // Light gray background
                    borderRadius: "8px",        // Optional: Rounded corners
                  }}               
                  onChange={e => setPhone(e.target.value)}
                />
                <TextField
                  variant="filled"
                  //margin="normal"                                    
                  name="address"
                  label="Katuosoite"                                 
                  id="katuosoite1"
                  autoComplete="katuosoite"
                  sx={{
                    width: 1,
                    backgroundColor: "white", // Light gray background
                    borderRadius: "8px",        // Optional: Rounded corners
                  }} 
                  onChange={e => setAddress(e.target.value)}
                />
                <TextField
                  variant="filled"
                  //margin="normal"                                    
                  name="address2"
                  label="Katuosoite 2"                  
                  id="katuosoite2"                  
                  sx={{
                    width: 1,
                    backgroundColor: "white", // Light gray background
                    borderRadius: "8px",        // Optional: Rounded corners
                  }} 
                  onChange={e => setAddress2(e.target.value)}
                />
                <TextField
                  variant="filled"
                  //margin="normal"                                    
                  name="postalcode"
                  label="Postinumero"                                
                  id="postalcode"
                  autoComplete="postinumero"
                  sx={{
                    width: 1,
                    backgroundColor: "white", // Light gray background
                    borderRadius: "8px",        // Optional: Rounded corners
                  }} 
                  onChange={e => setPostalcode(e.target.value)}
                />
                <TextField
                  variant="filled"
                  //margin="normal"                                    
                  name="city"
                  label="Toimipaikka"                           
                  id="toimipaikka"
                  autoComplete="toimipaikka"
                  sx={{
                    width: 1,
                    backgroundColor: "white", // Light gray background
                    borderRadius: "8px",        // Optional: Rounded corners
                  }} 
                  onChange={e => setCity(e.target.value)}
                />                                                
            </Stack>
            </div>
            <div className="flex-1">
              <h1 className="text-sm text-white">Julkiset tiedot</h1>
              <h1 className="text-sm text-white mb-2">kaikkien sivuston kävijöiden nähdävillä, kun paikka on maksettu</h1>
        <Stack direction="column" className="bg-blue-500 px-2 py-2 rounded-lg" alignItems="center" justifyContent="center" spacing={2}>        
        <TextField
                  variant="filled"
                  //margin="normal"
                  required                  
                  id="name"
                  label="Yrityksen / yhdistyksen / myyjän nimi"
                  name="name"
                  autoComplete="nimi"
                  autoFocus
                  sx={{
                    width: 1,
                    backgroundColor: "white", // Light gray background
                    borderRadius: "8px",        // Optional: Rounded corners
                  }}
                  InputProps={{
                    readOnly: true, // Makes the field read-only
                  }}       
                  value={name}            
                />
                <TextField
                  variant="filled"
                  //margin="normal"                      
                  id="email"
                  label="Sähköposti"
                  name="publicEmail"
                  autoComplete="sähköposti"   
                  sx={{
                    width: 1,
                    backgroundColor: "white", // Light gray background
                    borderRadius: "8px",        // Optional: Rounded corners
                  }}               
                  onChange={e => setPublicEmail(e.target.value)}
                />
                <TextField
                  variant="filled"
                  //margin="normal"                                
                  id="phone"
                  label="Puhelin"
                  name="phone"
                  autoComplete="phonenumber"    
                  sx={{
                    width: 1,
                    backgroundColor: "white", // Light gray background
                    borderRadius: "8px",        // Optional: Rounded corners
                  }}               
                  onChange={e => setPublicPhone(e.target.value)}
                />
                <TextField
                  variant="filled"
                  //margin="normal"                                    
                  name="homepage"
                  label="Kotisivut"                           
                  id="homepage"
                  autoComplete="homepage"
                  sx={{
                    width: 1,
                    backgroundColor: "white", // Light gray background
                    borderRadius: "8px",        // Optional: Rounded corners
                  }} 
                  onChange={e => setHomepage(e.target.value)}
                />
                <TextField
                  variant="filled"
                  //margin="normal"                                    
                  name="facebook"
                  label="Facebook"                                 
                  id="facebook"
                  autoComplete="facebook"
                  sx={{
                    width: 1,
                    backgroundColor: "white", // Light gray background
                    borderRadius: "8px",        // Optional: Rounded corners
                  }} 
                  onChange={e => setFacebook(e.target.value)}
                />
                <TextField
                  variant="filled"
                  //margin="normal"                                    
                  name="instagram"
                  label="Instagram"                  
                  id="instagram"                  
                  sx={{
                    width: 1,
                    backgroundColor: "white", // Light gray background
                    borderRadius: "8px",        // Optional: Rounded corners
                  }} 
                  onChange={e => setInstagram(e.target.value)}
                />
                <TextField
                  variant="filled"
                  //margin="normal"                                    
                  name="description"
                  label="Kuvaus, myytävät tuotteet tms."                                
                  id="description"                  
                  sx={{
                    width: 1,
                    backgroundColor: "white", // Light gray background
                    borderRadius: "8px",        // Optional: Rounded corners
                  }} 
                  onChange={e => setDescription(e.target.value)}
                />
                
                
                
                
            </Stack>
            </div>
            </div>

            
            <Stack direction="row" alignItems="center" justifyContent="center" sx={{p: 2}} spacing={2}>
                <Button type="submit" variant="contained" color="primary">Lähetä</Button>                
                <Button variant="contained"  color="secondary" onClick={handleGoBack}>Takaisin</Button>
            </Stack>
            
        </form>
    </div>
    </>
  )
}
